// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__3j1pr","profile__blockHeader":"Profile_profile__blockHeader__2cO2H"};